import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthorService } from 'src/app/services/self-serve/author.service';
import { ActivatedRoute } from '@angular/router';
import { ISimulationUpdate } from 'src/app/interfaces/self-serve/requests/isimulation-update';
import { ISimulation } from 'src/app/interfaces/self-serve/responses/isimulation';
import { TabsInnerWrapComponent } from "../../components/tabs-inner-wrap/tabs-inner-wrap.component";
import { GuidedSimulationInformationComponent } from "./guided-simulation-information/guided-simulation-information.component";
import { IFetchSimulationDetails } from 'src/app/interfaces/self-serve/responses/ifetch-simulation-details';

@Component({
  selector: 'guided-simulation-details',
  standalone: true,
  templateUrl: './guided-simulation-details.component.html',
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    TabsInnerWrapComponent,
    GuidedSimulationInformationComponent
],
})
export class GuidedSimulationDetailsComponent {
  form!: FormGroup;
  callUuid: string = '';
  @Input() simulationDetails: IFetchSimulationDetails | null = null;

  constructor(
    private authorService: AuthorService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap.get('uuid')!;

    console.log("Guided simulation details in details", this.simulationDetails);
  }
}
